import { generatePath, useHistory } from "react-router-dom";
import useModalLinkPrinter from "hooks/useModalLinkPrinter";
import { Routes } from "../../router/config";

export default function useController() {
  const history = useHistory();
  const { getLocation } = useModalLinkPrinter();

  const onResetStart = (data: { email: string; status: boolean }) => {
    history.push(getLocation(generatePath(Routes.loginForgotByEmail, { email: data.email })));
  };

  const onCodeVerified = (data: { email: string; token: string }) => {
    history.push(getLocation(generatePath(Routes.loginForgotByEmailByToken, { email: data.email, token: data.token })));
  };

  return {
    onResetStart,
    onCodeVerified,
  };
}
